/**
 * Utility functions for file operations that don't require a backend
 */

/**
 * Save an image file locally and return a promise with the relative path
 * @param {File} file - The image file to process
 * @param {string} projectName - Name to use for the file
 * @returns {Promise<string>} - Promise that resolves to the image path
 */
export const processImageFile = (file, projectName) => {
  return new Promise((resolve) => {
    // Create a file reader to read the file
    const reader = new FileReader();
    
    reader.onload = (event) => {
      // Get the data URL from the file (base64 encoded)
      const imageDataUrl = event.target.result;
      
      // In development mode, we just return the data URL as the path
      // In a real backend, this would be saved as a file and we'd return the path
      resolve(imageDataUrl);
    };
    
    // Read the file as a data URL
    reader.readAsDataURL(file);
  });
};

/**
 * Save a project file locally without a backend
 * @param {Array} projects - Array of project objects to save
 * @returns {Promise<boolean>} - Promise that resolves when the save is complete
 */
export const saveProjectsLocally = (projects) => {
  return new Promise((resolve) => {
    // Save to localStorage for persistence
    try {
      localStorage.setItem('portfolio_projects', JSON.stringify(projects));
      resolve(true);
    } catch (error) {
      console.error('Error saving projects to localStorage:', error);
      resolve(false);
    }
  });
};

/**
 * Load projects from localStorage
 * @returns {Array|null} - Array of projects or null if none found
 */
export const loadProjectsLocally = () => {
  try {
    const projectsJson = localStorage.getItem('portfolio_projects');
    return projectsJson ? JSON.parse(projectsJson) : null;
  } catch (error) {
    console.error('Error loading projects from localStorage:', error);
    return null;
  }
}; 